// Backgrounding an Android app suspends its network and drops the VPN tunnel, so
// requests in flight time out and requests fired on resume fail. Those aren't real
// errors. Track foreground state so error-handler can ignore them. Native-only: on
// web setAppActive is never called, so nearAppTransition() stays false.

const BG_GRACE_MS = 5000
const appState = { isActive: true, lastTransitionAt: 0 }

export function setAppActive(isActive) {
  appState.isActive = isActive
  appState.lastTransitionAt = Date.now()
}

export function nearAppTransition() {
  return !appState.isActive || Date.now() - appState.lastTransitionAt < BG_GRACE_MS
}

// Response-less timeout/network error around a background transition.
export function isBackgroundTransient(error) {
  if (!error || error.response) return false
  if (error.code !== 'ECONNABORTED' && error.code !== 'ERR_NETWORK') return false
  return nearAppTransition()
}
